import { render, staticRenderFns } from "./CandidateCourses.vue?vue&type=template&id=35c7a1fc&scoped=true"
import script from "./CandidateCourses.vue?vue&type=script&lang=ts"
export * from "./CandidateCourses.vue?vue&type=script&lang=ts"
import style0 from "./CandidateCourses.vue?vue&type=style&index=0&id=35c7a1fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7a1fc",
  null
  
)

export default component.exports